<template>
  <div>
    <!-- <ContactFloatingBtn /> -->
    <!-- <Header /> -->
    <HeroSlider />
    <section class="section1">
      <div class="section-inner">
        <h2 class="section-title">Trading Platforms & Exchanges | Brokerage Solutions</h2>
        <PlatformTab />
      </div>
    </section>
    <section class="section2">
      <div class="section-inner">
        <div class="col">
          <img src="@/assets/icons/feature-icon1.svg" alt="" />
          <h5 class="feature-title">{{ $t('mainPage.section2.feature-title1') }}</h5>
          <p class="feature-content">{{ $t('mainPage.section2.feature-content1') }}</p>
        </div>
        <div class="col">
          <img src="@/assets/icons/feature-icon2.svg" alt="" />
          <h5 class="feature-title">{{ $t('mainPage.section2.feature-title2') }}</h5>
          <p class="feature-content">{{ $t('mainPage.section2.feature-content2') }}</p>
        </div>
        <div class="col">
          <img src="@/assets/icons/feature-icon3.svg" alt="" />
          <h5 class="feature-title">{{ $t('mainPage.section2.feature-title3') }}</h5>
          <p class="feature-content">{{ $t('mainPage.section2.feature-content3') }}</p>
        </div>
        <div class="col">
          <img src="@/assets/icons/feature-icon4.svg" alt="" />
          <h5 class="feature-title">{{ $t('mainPage.section2.feature-title4') }}</h5>
          <p class="feature-content">{{ $t('mainPage.section2.feature-content4') }}</p>
        </div>
        <div class="col">
          <img src="@/assets/icons/feature-icon5.svg" alt="" />
          <h5 class="feature-title">{{ $t('mainPage.section2.feature-title5') }}</h5>
          <p class="feature-content">{{ $t('mainPage.section2.feature-content5') }}</p>
        </div>
        <div class="col">
          <img src="@/assets/icons/feature-icon6.svg" alt="" />
          <h5 class="feature-title">{{ $t('mainPage.section2.feature-title6') }}</h5>
          <p class="feature-content">{{ $t('mainPage.section2.feature-content6') }}</p>
        </div>
      </div>
    </section>
    <section class="section3 orange">
      <div class="section-inner">
        <h2 class="section-title">{{$t("mainPage.section3.title")}}</h2>
        <p>{{$t("mainPage.section3.para")}}</p>
        <router-link to="contact" class="contact-us"><BtnPrimary text="Contact us" inverse /></router-link>
      </div>
    </section>
  </div>
</template>

<script>
// import Footer from '@/components/Footer.vue'
// import Header from  '@/components/Header.vue'
import HeroSlider from '@/components/HeroSlider.vue';
import BtnPrimary from '@/components/BtnPrimary.vue';
import PlatformTab from '@/components/PlatformTab.vue';
// import ContactFloatingBtn from '../components/ContactFloatingBtn.vue';
export default {
  name: 'MainPage',
  components: { HeroSlider, BtnPrimary, PlatformTab },

  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="scss" scoped></style>
